import { render, staticRenderFns } from "./NewIQCQuery.vue?vue&type=template&id=25e71ec8&scoped=true"
import script from "./NewIQCQuery.vue?vue&type=script&lang=js"
export * from "./NewIQCQuery.vue?vue&type=script&lang=js"
import style0 from "./NewIQCQuery.vue?vue&type=style&index=0&id=25e71ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e71ec8",
  null
  
)

export default component.exports